export default __webpack_public_path__ + "static/media/right_open_arrow.b3864716.svg";